/*
 * ErrorBoundary Messages
 *
 * This contains all the text for the ErrorBoundary component.
 */
import { defineMessages } from 'react-intl';

const messages = {
  title: {
    id: 'ERROR_BOUNDARY.title',
    defaultMessage: 'Something went wrong',
  },
  revealDetails: {
    id: 'ERROR_BOUNDARY.revealDetails',
    defaultMessage: 'Reveal details',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/organisms/ErrorBoundary/messages.js